export default ({ customFieldsInVuelidate, customField, indexOfField }) => {
  if (customFieldsInVuelidate && customFieldsInVuelidate[indexOfField]?.$error) {
    const errors = []
    const { required, numeric, decimal } = customFieldsInVuelidate[indexOfField].Values[0].$params
    if (required !== null) errors.push('is required')
    if (numeric !== null) errors.push('must be an integer')
    if (decimal !== null) errors.push('must be a decimal number')
    const combinedErrorMessage = [errors.pop(), errors.join(', ')]
      .filter(v => v)
      .reverse()
      .join(' and ')

    return `${customField.FieldName} ${combinedErrorMessage}`
  } else {
    return ''
  }
}
